module.exports = __webpack_public_path__ + "img/gargoyle_wollust.feb4d716.png";